export const ACCOUNT_VALIDATION_KEYS = {
  ERROR: 'error',
  EMAIL: 'email',
  NAME: 'name',
  LAST_NAME: 'last_name',
  PASSWORD: 'password',
  CONFIRM_PASSWORD: 'password2',
  ROLE: 'role',
  TERMS: 'terms',
  COMPANY_NAME: 'company_name',
  COMPANY_URL: 'company_url',
} as const;

export const ACCOUNT_VALIDATION_MESSAGES = {
  SPECIFY_FIRST_NAME: 'Please specify a valid first name.',
  SPECIFY_SHORTER_FIRST_NAME: 'Please specify a shorter name.',
  SPECIFY_LAST_NAME: 'Please specify a valid last name.',
  SPECIFY_SHORTER_LAST_NAME: 'Please specify a shorter last name.',
  SPECIFY_EMAIL: 'Please specify an email address.',
  SPECIFY_VALID_EMAIL: 'Please specify a valid email address eg. myname@email.com.',
  SPECIFY_SHORTER_EMAIL: 'Please specify a shorter email.',
  SPECIFY_PASSWORD: 'Please specify a password.',
  PASSWORDS_DONT_MATCH: "Passwords don't match.",
  PASSWORD_INVALID: 'Password invalid.',
  SPECIFY_ROLE: 'Please specify a role.',
  ACCEPT_TERMS: 'Please accept the Terms & Conditions and Privacy Policy to continue.',
  SPECIFY_COMPANY_NAME: 'Please specify a valid company name.',
  SPECIFY_SHORTER_COMPANY_NAME: 'Please specify a shorter company name.',
  SPECIFY_COMPANY_URL: 'Please specify a valid URL.',
  SPECIFY_SHORTER_COMPANY_URL: 'Please specify a shorter URL.',
} as const;
